module.exports = __webpack_public_path__ + "static/media/logo-uniao-seguradora-negativo.91823021.png";